import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import HotSpot from './HotSpotBtn';
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as navigationHelper from '../../../helpers/navigationHelper';
import {SCREEN_CONFIG} from '../../../models/dialogModels';
import {HOT_SPOT_MAX_SIZES} from '../../../models/objectModels';

import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";

class HotspotScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            settings: appHelper.getArrayObjectByKey(HOT_SPOT_MAX_SIZES,"constant",props.screen.hotspot_type),
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",
                },
                hotspotBackground: {
                    src: "",
                }
            },
            activeScreen: {},
            viewedScreens: [],
            hotspotScreens: [],
            //introductionScreen: {},
            //conclusionScreen: {},
            enabledScreens: [],
            completeScreens: [],
            checkNextSlideBtnState: false,
            //hasIntroduction: this.props.hasIntroduction,
            //introductionStatus: objectConstants.STATUS_NOT_STARTED,
           // launchIntroduction: false,
            //hasConclusion: this.props.hasConclusion,
            //conclusionStatus: objectConstants.STATUS_NOT_STARTED,
            //launchConclusion: false,
            firstScreen: {},
            launchFirstScreen: false,
            scrollState: "",
            checkScrollPos: false,
            producerNotes: appHelper.getScreenNotes(undefined, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: appHelper.isDefined(this.props.screen.sub_screens),// && this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(this.props.screen),
            doSetRenderedScreens: false,
            setEnabledHotSpots: false,
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
           // introduction_label: appHelper.getLocaleString("introduction_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            //conclusion_label: appHelper.getLocaleString("conclusion_label"),
            scroll_label: appHelper.getLocaleString("scroll_label"),
            //showIntroductionBtn: false,
            setNextButton: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status === objectConstants.STATUS_COMPLETE,
            setSettings: false,
            height: undefined,
            updateHeight: false,
            updateForced: false,
            continuePositionSet: false,
            maxHeight: 690,
        };

        this.continueBtn =  React.createRef();

        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.readySetRenderedScreens = this.readySetRenderedScreens.bind(this);
        this.setEnabledHotSpots = this.setEnabledHotSpots.bind(this);
        this.setActiveHotspot = this.setActiveHotspot.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setRenderedScreens = this.setRenderedScreens.bind(this);
        this.setScreenHasBeenViewed = this.setScreenHasBeenViewed.bind(this);
        this.checkScreenIsEnabled = this.checkScreenIsEnabled.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.launchScreen = this.launchScreen.bind(this);
        this.checkHotSpotsAreComplete = this.checkHotSpotsAreComplete.bind(this);
        this.onCloseScreen = this.onCloseScreen.bind(this);
        this.showFooter = this.showFooter.bind(this);
        this.hasFooterClass = this.hasFooterClass.bind(this);
        //this.showIntroduction = this.showIntroduction.bind(this);
        //this.showConclusion = this.showConclusion.bind(this);
        this.checkScrolling = this.checkScrolling.bind(this);
        this.setScreenTitle = this.setScreenTitle.bind(this);
        //this.readyIntroduction = this.readyIntroduction.bind(this);
        //this.readyConclusion = this.readyConclusion.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.getCompletedSubScreens = this.getCompletedSubScreens.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.allowScroll = this.allowScroll.bind(this);
        this.setButtonColour = this.setButtonColour.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        //this.getIntroductionStatusClass = this.getIntroductionStatusClass.bind(this);
        //this.getConclusionStatusClass = this.getConclusionStatusClass.bind(this);
        this.setScreenSettings = _.debounce(this.setScreenSettings.bind(this),1000);
        this.setHeight = this.setHeight.bind(this);
        //this.getHeight = this.getHeight.bind(this);
        this.checkHeight = this.checkHeight.bind(this);
        this.componentWatcher = this.componentWatcher.bind(this);
        this.getContinuePosition = this.getContinuePosition.bind(this);
        this.getContinueState = this.getContinueState.bind(this);
        this.setMaxHeight = this.setMaxHeight.bind(this);

        this.background = React.createRef();
        this.backgroundImage = React.createRef();
        this.feed = React.createRef();
        this.continueBtn = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        this.props.actions.setNextButtonState(false);
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);

        this.getAssets();
        this.setCallbacks();
        if (this.state.screenIsReady) {
            //this.setEnabledHotSpots();
            let readySetRenderedScreens = this.readySetRenderedScreens;
            setTimeout(function () {
                readySetRenderedScreens();
            }, 1000);
            //this.readySetRenderedScreens();
            //this.setRenderedScreens();
        } else {
            this.setScreenNotReadyYet();
        }

        this.setScreenTitle();
        let feed = this.feed.current;
        if(appHelper.isEleDefined(feed)) {
            feed.addEventListener("scroll", this.checkScrolling);
        }
        this.getHeight();
        this.getContinuePosition();
        this.setMaxHeight();
        //this.setActiveHotspot(this.state.screen.sub_screens[0]);

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        //let introductionStatus = this.state.introductionStatus;
        //let conclusionStatus = this.state.conclusionStatus;

        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                //introductionStatus: introductionStatus,
                setEnabledHotSpots: true
            });
        }

        /*if (this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.introductionScreen.data)) {
            introductionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.introductionScreen.data.screen_id).status;
            this.setState({
                introductionStatus: introductionStatus,
                //setEnabledHotSpots: true
            });
        }*/

        /*if (this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.conclusionScreen.data)) {
            conclusionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.conclusionScreen.data.screen_id).status;
            this.setState({
                conclusionStatus: conclusionStatus,
                //setEnabledHotSpots: true
            });
        }*/

        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({

                status: screenUserData.status,
                setNextButton: true,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                //introduction_label: appHelper.getLocaleString("introduction_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                //conclusion_label: appHelper.getLocaleString("conclusion_label"),
                scroll_label: appHelper.getLocaleString("scroll_label"),
            });
            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }

        if(this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview){
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(undefined, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }
        //this.setState({setEnabledHotSpots: true });
    }


    componentDidUpdate() {


        if (this.state.launchFirstScreen) {
            this.launchScreen(this.state.firstScreen);
        }

        /*if (this.state.launchIntroduction) {
            this.readyIntroduction();
        }

        if (this.state.launchConclusion) {
            this.readyConclusion();
        }*/

        if (this.state.checkScrollPos) {
            this.checkScrolling();
        }

        if (this.state.doSetRenderedScreens) {
            this.setRenderedScreens();
        }

        if (this.state.setEnabledHotSpots) {
            this.setEnabledHotSpots();
        }

        if(this.state.setNextButton){
            this.handleNextButton();
        }

        if(this.state.setSettings){
            this.setScreenSettings();
        }

        if(this.state.updateHeight){
            this.setHeight();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
        let feed = this.feed.current;
        if(appHelper.isEleDefined(feed)) {
            feed.removeEventListener("scroll", this.checkScrolling);
        }
    }


    readySetRenderedScreens() {

        this.setState({
            setEnabledHotSpots: true
        });
    }

    setScreenAccessed() {
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet() {
        this.setState({status: objectConstants.STATUS_COMPLETE, setNextButton: true});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    /*readyIntroduction() {
        if (this.state.producerNotes.show_content) {
            let showIntroduction = this.showIntroduction;
            let introductionScreen = this.state.introductionScreen;

            setTimeout(function () {
                showIntroduction(introductionScreen);
            }, 1000);
        }
    }

    readyConclusion() {
        if (this.state.producerNotes.show_content) {
            let launchScreen = this.launchScreen;
            let conclusionScreen = this.state.conclusionScreen;
            setTimeout(function () {
                launchScreen(conclusionScreen);
            }, 1000);
        }
    }*/

    setScreenTitle() {
        this.props.actions.setScreenTitle(this.state.locale.title);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                setNextButton: true,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
            });
        }
    }

    getAssets() {
        let background = {};
        let hotspotBackground = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
            hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
        }
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground
            }),
            checkScrollPos: true,
            setSettings: true
        });

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    showFooter() {

        return this.state.status === objectConstants.STATUS_COMPLETE || this.state.scrollState === 'scroll' || this.state.isOpenNavigation;
    }

    hasFooterClass() {
        return this.showFooter() ? "include-footer" : "";
    }

    setEnabledHotSpots() {
        this.setState({setEnabledHotSpots: false});
        if (this.state.producerNotes.show_content && (appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression === objectConstants.LINEAR) && this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({
                doSetRenderedScreens: true,
                enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0]),
                activeScreen: this.state.screen.sub_screens[0]
            });

        } else {
            this.setState({
                doSetRenderedScreens: true,
                enabledScreens: Object.assign([], this.state.screen.sub_screens),
            });
        }
    }

    checkScreenIsEnabled(screen) {
        let enabledIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", screen.screen_id);
        return enabledIndex > -1;
    }

    setActiveHotspot(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
        this.setState(
            {
                activeScreen: screen
            }
        );

        if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
            let renderedScreen = {};
            _.forEach(this.state.hotspotScreens, function (hs_screen) {
                if (hs_screen.data.screen_id === screen.screen_id) {
                    renderedScreen = Object.assign({}, hs_screen);
                }
            });
            if(appHelper.isDefined(renderedScreen.data)) {
                this.launchScreen(renderedScreen);
            }
        } /*else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
            this.setState({showIntroductionBtn: true});
            this.launchScreen(this.state.introductionScreen);
        } else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
            this.launchScreen(this.state.conclusionScreen);
        }*/
    }

    setScreenHasBeenViewed(screen) {
        let viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
        if (viewedIndex === -1) {
            this.setState({viewedObjects: dataHelper.immutablePush(this.state.viewedScreens, screen)});
        }

    }

    setRenderedScreens() {
        //console.log(`setRenderedScreens`);
        this.setState({doSetRenderedScreens: false});
        let hotspotScreens = [];
        let userData = this.state.userData;
        let parentScreen = this.state.screen;
        let firstScreen = {};
        let firstScreenData = Object.assign({}, this.state.screen.sub_screens[0]);
        let firstScreenStatus =  userDataHelper.getSubScreenUserData(userData, parentScreen.screen_id, firstScreenData.screen_id);
        let launchFirstScreen = firstScreenStatus.status !== objectConstants.STATUS_COMPLETE && (appHelper.isDefined(this.state.screen.open_first_hotspot_onload) && this.state.screen.open_first_hotspot_onload);


        _.forEach(this.state.screen.sub_screens, function (sub_screen, index) {
            let screenType = Object.assign({}, getScreenComponentByType(sub_screen.screen_type),
                {
                    data: sub_screen
                }
            );


            if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
                hotspotScreens = dataHelper.immutablePush(hotspotScreens, screenType);
            }

            if(index === 0){
                firstScreen = Object.assign({}, screenType);
            }
            /* else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
                introductionScreen = Object.assign({}, screenType);
                introductionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, introductionScreen.data.screen_id).status;
                //console.log(`introductionStatus`,introductionStatus);
            } else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
                conclusionScreen = Object.assign({}, screenType);
                conclusionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, conclusionScreen.data.screen_id).status;
            }*/

        });

        let completeScreens = this.getCompletedSubScreens();
        let enabledScreens = this.getCompletedSubScreens();

        if (appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression !== objectConstants.LINEAR || !this.state.producerNotes.show_content) {
            enabledScreens = Object.assign([], this.state.screen.sub_screens);

        } else if (enabledScreens.length > 0 && enabledScreens.length < this.state.screen.sub_screens.length) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[enabledScreens.length]);
            enabledScreens = dataHelper.immutablePush(enabledScreens, nextScreen);
            this.setActiveHotspot(nextScreen);
        } else {

            enabledScreens = dataHelper.immutablePush(enabledScreens, firstScreenData);

            //enabledScreens =  dataHelper.immutablePush(this.state.screen.sub_screens[0]);

        }



        // console.log(`completeScreens`,completeScreens);

        //let introductionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", introductionScreen.screen_id);
        //let conclusionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", conclusionScreen.screen_id);

        /*if (introductionIndex > -1) {
            introductionStatus = objectConstants.STATUS_COMPLETE;
        }

        if (conclusionIndex > -1) {
            conclusionStatus = objectConstants.STATUS_COMPLETE;
        }*/
        //console.log(`launchIntroduction`,this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE);
        //console.log(`launchConclusion`,completeScreens.length === (this.state.screen.sub_screens.length - 1) && this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE);

        this.setState({
            hotspotScreens: Object.assign([], hotspotScreens),
            launchFirstScreen: launchFirstScreen,
            firstScreen: firstScreen,
            //introductionScreen: Object.assign({}, introductionScreen),
            //introductionStatus: introductionStatus,
            //conclusionScreen: Object.assign({}, conclusionScreen),
            //conclusionStatus: conclusionStatus,
            //launchIntroduction: this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE,
            enabledScreens: Object.assign([], enabledScreens),
            completeScreens: Object.assign([], completeScreens),
            //launchConclusion: completeScreens.length === (this.state.screen.sub_screens.length - 1) && this.state.hasConclusion && conclusionStatus === objectConstants.STATUS_NOT_STARTED
        });
    }

    getCompletedSubScreens() {
        let completedScreens = [];
        let userData = this.state.userData;
        let parentScreen = this.state.screen;
        _.forEach(this.state.screen.sub_screens, function (sub_screen) {
            let screenUserData = userDataHelper.getSubScreenUserData(userData, parentScreen.screen_id, sub_screen.screen_id);
            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
                completedScreens = dataHelper.immutablePush(completedScreens, sub_screen);
            }
        });

        return completedScreens;
    }


    onSubScreenComplete(screen) {
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
        }


        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true,
                    checkNextSlideBtnState: true
                }


            );
            this.setActiveHotspot(nextScreen);
            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, screen.screen_id);
        }

        this.checkScreenComplete();

    }

    checkHotSpotsAreComplete() {
        let completedHotSpots = 0;
        let completeScreens = this.state.completeScreens;
        _.forEach(this.state.hotspotScreens, function (screen) {
            let screen_id = screen.data.screen_id;
            let completionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", screen_id);
            if (completionIndex > -1) {
                completedHotSpots++;
            }
        });
        return completedHotSpots === this.state.hotspotScreens.length;
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setActiveHotspot(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    navigateToNextScreen() {

        if (this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }

        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            this.goToScreen(this.state.screen.next_screen_id);
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                this.context.router.push('menu');
            } else {
                this.props.actions.setNextLessonLocation(this.getScreenId());
            }
        }

    }

    checkScreenComplete() {
        if (appHelper.isDefined(this.state.screen.sub_screens) && this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE,
                    setNextButton: true,
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen() {
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE,
                setNextButton: true,
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };
        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    launchScreen(renderedScreen) {
        if(appHelper.isDefined(renderedScreen.data)) {
            this.setState({
                launchFirstScreen: false,

            });

            let config = Object.assign({}, SCREEN_CONFIG,
                {
                    component: renderedScreen.component,
                    biteCallbacks: this.state.callbacks,
                    parentScreen: {
                        screen_id: this.state.screen.screen_id
                    },
                    screen: {
                        screen_id: renderedScreen.data.screen_id
                    },
                    onClose: this.onCloseScreen,
                    sourceId: `hotSpot_${renderedScreen.data.screen_id}`

                }
            );

            if (this.state.screenIsReady) {

                this.props.actions.setNewScreenDialog(config);
            }
        }
    }

    onCloseScreen() {
        /*let launchConclusion = this.checkHotSpotsAreComplete() && this.state.hasConclusion && this.state.conclusionStatus === objectConstants.STATUS_NOT_STARTED;
        this.setState({launchConclusion: launchConclusion});*/
    }

    /*showIntroduction() {
        this.setState({showIntroductionBtn: true});
        this.launchScreen(this.state.introductionScreen);
    }

    showConclusion() {
        this.launchScreen(this.state.conclusionScreen);
    }*/

    checkScrolling() {
        this.setState({checkScrollPos: false});
        let feed = this.feed.current;
        let hotspot_background = this.background.current;
        let windowHeight = window.innerHeight;
        //console.log(`checkScrolling hotspot_background.offsetHeight > - feed.offsetHeight`,hotspot_background.offsetHeight,` >  `,feed.offsetHeight);
        if (appHelper.isEleDefined(hotspot_background) && appHelper.isEleDefined(feed)) {

            if (hotspot_background.offsetHeight > feed.offsetHeight && feed.scrollTop < (hotspot_background.offsetHeight - feed.offsetHeight) && (appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable)) {
                this.setState({
                    scrollState: "scroll"
                });

            } else if (windowHeight < (appConstants.DESKTOP_MAX_HEIGHT - 5) && hotspot_background.offsetHeight > feed.offsetHeight && feed.scrollTop < (hotspot_background.offsetHeight - feed.offsetHeight)) {
                this.setState({
                    scrollState: "scroll"
                });
                /*} else if(windowHeight < (appConstants.DESKTOP_MAX_HEIGHT - 5) &&  feed.scrollTop <= (hotspot_background.offsetHeight - feed.offsetHeight) ){
                    this.setState({
                        scrollState: ""
                    });*/
            } else {
                this.setState({
                    scrollState: ""
                });
            }
        }
    }

    scrollToBottom() {
        let feed = this.feed.current;
        let background = this.background.current;
        if (appHelper.isEleDefined(feed) && appHelper.isEleDefined(background)) {
            let height = background.offsetHeight > feed.offsetHeight ? background.offsetHeight : feed.offsetHeight;

            let params = {
                ele: feed,
                duration: 0.5,
                delay: 0,
                scrollTop: height,
                callback: null
            };

            animationHelper.scrollTo(params);
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.scrollToBottom();
        }
    }

    allowScroll() {
        return appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable;
    }

    setButtonColour() {
        if (this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_NO_SCREEN || this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_FULL_SCREEN) {
            if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    background: `${this.state.screen.hotspot_colour} !important`,
                    color: `${this.state.screen.hotspot_label_colour} !important`
                };
            } else if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour === objectConstants.INHERIT) {
                return {
                    background: `${this.state.screen.hotspot_colour} !important`

                };
            } else if (this.state.screen.hotspot_colour === objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    color: `${this.state.screen.hotspot_label_colour} !important`
                };
            } else {
                return {};
            }
        } else {
            return {};
        }

    }

    getNextlessonLocation(){
        let next_lesson_location = 0;
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            next_lesson_location = this.state.screen.next_screen_id;
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {

                next_lesson_location = navigationHelper.getNextLessonLocation(this.getScreenId());
            }
        }

        return next_lesson_location;
    }

    handleNextButton(){
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if(next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    /*getIntroductionStatusClass(){
        if (this.state.introductionStatus === objectConstants.STATUS_NOT_STARTED || this.state.introductionStatus === objectConstants.STATUS_NOT_REQUIRED) {
            return "not-started";
        } else if (this.state.introductionStatus === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (this.state.introductionStatus === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    getConclusionStatusClass(){
        if (this.state.conclusionStatus === objectConstants.STATUS_NOT_STARTED || this.state.conclusionStatus === objectConstants.STATUS_NOT_REQUIRED) {
            return "not-started";
        } else if (this.state.conclusionStatus === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (this.state.conclusionStatus === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }*/

    setScreenSettings(){
        if(!this.state.updateForced){
            this.forceUpdate();
            this.setState({updateForced: true, setSettings: true});
        }
        let image = this.backgroundImage.current;
        if(appHelper.isEleDefined(image)) {
            let imageWidth = image.offsetWidth;

            let imageHeight = image.offsetHeight;

            let contentDetails = this.checkHeight();

            //if(imageWidth < appConstants.DESKTOP_MAX_WIDTH){
            let calculatedHeight = Math.round((imageWidth / appConstants.DESKTOP_MAX_WIDTH) * (appConstants.DESKTOP_MAX_HEIGHT - (contentDetails.headerHeight)));
            //console.log(`calculatedHeight`,calculatedHeight, contentDetails.headerHeight);
            //}


            if(imageHeight < calculatedHeight){
                imageHeight = calculatedHeight;


            }


            let percentageOfMaxWidth = Math.round((imageWidth / this.state.settings.maxWidth) * 100);

            let maxHeight = Math.round((imageHeight / percentageOfMaxWidth) * 100);


            // console.log(`imageWidth ${imageWidth} : maxWidth ${this.state.settings.maxWidth} : percentageOfMaxWidth ${percentageOfMaxWidth} , imageHeight ${imageHeight}, calculatedHeight ${calculatedHeight}  : maxHeight ${maxHeight} : contentHeight ${contentDetails.contentHeight}`);

            this.setState({
                setSettings: false,
                updateHeight: true,
                settings: Object.assign({},this.state.settings,{
                    percentageOfMax: percentageOfMaxWidth,
                    maxHeight: maxHeight ,
                })
            });
        }
        this.getContinuePosition();
    }

    checkHeight(){
        let windowHeight = window.innerHeight;
        let mainWrapper = document.getElementById('main-wrapper');
        //console.log(`setHeight mainWrapper`,mainWrapper.offsetHeight, `windowHeight:`, windowHeight);
        let header = document.getElementById('scenarioBiteHeader');
        let progress =  document.getElementById('scenarioBiteProgress');
        let newHeight = (mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight);
        return {
            headerHeight: header.offsetHeight + progress.offsetHeight,
            windowHeight: windowHeight,
            contentHeight: mainWrapper.offsetHeight
        };
    }


    _setHeight(){
        this.setState({updateHeight: false});
        let windowHeight = window.innerHeight;
        //console.log(`windowHeight:`,windowHeight,` min:`,appConstants.DESKTOP_MIN_HEIGHT,` max: `, appConstants.DESKTOP_MAX_HEIGHT);
        let mainWrapper = document.getElementById('main-wrapper');
        //console.log(`setHeight mainWrapper`,mainWrapper.offsetHeight, `windowHeight:`, windowHeight);
        let header = document.getElementById('scenarioBiteHeader');
        let progress =  document.getElementById('scenarioBiteProgress');
        let newHeight = 0;

        //console.log(`auto`, appConstants.DESKTOP_MIN_HEIGHT, appConstants.DESKTOP_MAX_HEIGHT) ;
        if(appHelper.isEleDefined(header) && appHelper.isEleDefined(progress)) {

           newHeight = (mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight);
            if (this.state.settings.maxHeight > 0 && this.state.settings.maxHeight > mainWrapper.offsetHeight) {
                newHeight = mainWrapper.offsetHeight;
                //console.log(`1`,newHeight);
            }

            if (windowHeight >= appConstants.DESKTOP_MAX_HEIGHT) {
                newHeight = appConstants.DESKTOP_MAX_HEIGHT;
                //console.log(`2`,newHeight);
                //console.log(`auto`, appConstants.DESKTOP_MAX_HEIGHT);
            } else if (windowHeight >= appConstants.DESKTOP_MIN_HEIGHT && windowHeight < appConstants.DESKTOP_MAX_HEIGHT) {
                newHeight = (windowHeight - header.offsetHeight - progress.offsetHeight);
                if (this.state.settings.maxHeight > 0 && this.state.settings.maxHeight > windowHeight) {
                    // console.log(`3`,newHeight);
                }

                //console.log(`this is where i want to be ${newHeight}`);

            }

            if (windowHeight <= appConstants.DESKTOP_MIN_HEIGHT) {
                newHeight = windowHeight;
                //console.log(`4`,newHeight);
            }
        }
        //console.log(newHeight);

        //console.log(`set new height: ${newHeight}`);
        this.setState({height: newHeight});

    }
    setHeight(){

        this.setState({updateHeight: false});
        let windowHeight = window.innerHeight;
        let mainWrapper = document.getElementById('main-wrapper');
        //console.log(`setHeight mainWrapper`,mainWrapper.offsetHeight, `windowHeight:`, windowHeight);
        let header = document.getElementById('scenarioBiteHeader');
        let newHeight = 0;
        let progress =  document.getElementById('scenarioBiteProgress');
        if(appHelper.isEleDefined(header) && appHelper.isEleDefined(progress)) {

            newHeight = (mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight);

            if (appHelper.isDefined(windowHeight) && windowHeight !== null && appHelper.isDefined(mainWrapper) && mainWrapper !== null && appHelper.isDefined(header) && header !== null && appHelper.isDefined(progress) && progress !== null) {
                if (windowHeight >= appConstants.DESKTOP_MAX_HEIGHT || !appHelper.isDefined(header)) {
                    newHeight = appConstants.DESKTOP_MAX_HEIGHT;
                } else if (windowHeight >= appConstants.DESKTOP_MIN_HEIGHT && windowHeight < appConstants.DESKTOP_MAX_HEIGHT) {
                    newHeight = (windowHeight - header.offsetHeight - progress.offsetHeight);
                }

                if (appHelper.isDefined(header)) {
                    //console.log(`set new height: ${newHeight}`);
                    this.setState({height: newHeight, checkScrollPos: true});
                }
            }
        }
    }



    getHeight(){

        if(appHelper.isDefined(this.state.height) && this.state.height !== appConstants.DESKTOP_MAX_HEIGHT){
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        }else{
            return {};
        }
    }

    componentWatcher(){
        this.setState({updateHeight: true});
    }

    getContinuePosition(){
        let continueBtn = this.continueBtn.current;
        //console.log(`continueBtn`,continueBtn);

        if(continueBtn !== null) {
            let height = Math.round((this.state.settings.maxHeight / 100) * this.state.settings.percentageOfMax);
            let width = Math.round((this.state.settings.maxWidth / 100) * this.state.settings.percentageOfMax);
            let continueBtnHeight = continueBtn.offsetHeight;
            let continueBtnWidth = continueBtn.offsetWidth;
            let defaultY = height - continueBtnHeight - 30;
            let defaultX = width - continueBtnWidth - 80;

            let defaultPercentageX = (defaultX / width) * 100;
            let defaultPercentageY = (defaultY / height) * 100;

            if (typeof this.state.screen.continue_x_coordinate !== 'number' || typeof this.state.screen.continue_y_coordinate !== 'number') {
                TweenLite.set(continueBtn, {
                    left: defaultPercentageX > 0 ? `${defaultPercentageX}%` : `90%`,
                    top: defaultPercentageY > 0 ?`${defaultPercentageY}%` : `90%`,
                    opacity: defaultPercentageY > 0 ? 1 : 0,
                });
            } else if (this.state.settings.percentageOfMax !== 0) {
                let percentageX = (this.state.screen.continue_x_coordinate / width) * 100;
                let percentageY = (this.state.screen.continue_y_coordinate / height) * 100;
                TweenLite.set(continueBtn, {
                    left: `${percentageX}%`,
                    top: `${percentageY}%`,
                });
            } else {
                TweenLite.set(continueBtn, {
                    left: this.state.screen.continue_x_coordinate,
                    top: this.state.screen.continue_y_coordinate,
                });
            }
        }
    }

    getContinueState(){
        let enabled = (this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS  && this.state.screenIsReady);
        return !enabled;
    }

    setMaxHeight(){
        let header = document.getElementById('scenarioBiteHeader');
        let progress =  document.getElementById('scenarioBiteProgress');
        if(appHelper.isEleDefined(header) && appHelper.isEleDefined(progress)) {
            let maxHeight = (appConstants.DESKTOP_MAX_HEIGHT - header.offsetHeight - progress.offsetHeight);
            if (!isNaN(maxHeight)) {
                this.setState({maxHeight: maxHeight});
            }
        }
    }

    render() {
       /* if((this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS  ) && this.state.screenIsReady){
            this.getContinuePosition();
        }*/
        return (
            <div className="customer-scenario">
                <div className="background-container">
                    <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                </div>
                <div className="screen-container">
                    <div className={`hot-spot-screen ${this.state.screen.hotspot_type}`}>

                        <div
                            className={`hot-spot-content ${this.hasFooterClass()} ${!this.allowScroll() ? "no-scroll" : ""}`} style={{maxHeight: `${this.state.maxHeight}px`}}
                            ref={this.feed}>
                            <div className="hot-spot-background-container"
                                 ref={this.background}>
                                {
                                    appHelper.isDefined(this.state.assets.hotspotBackground.src) && appHelper.isDefined(this.state.screen.sub_screens)
                                        ?
                                        <img
                                            className={this.state.screen.sub_screens.length === 0 ? "image-overlay" : "hot-spot-background"}
                                            src={this.getImagePath(this.state.assets.hotspotBackground.src)} alt="" ref={this.backgroundImage}/>
                                        :
                                        null
                                }
                                {appHelper.isDefined(this.state.screen.sub_screens) && this.state.screenIsReady
                                    ?
                                    <div className="hot-spot-area" >{/*style={this.getHeight()}*/}

                                        {this.state.screen.include_instructions && appHelper.isDefined(this.state.locale.instructions) && this.state.locale.instructions.length > 0 && this.state.locale.instructions !== "<p><br/></p>"
                                            ?
                                            <div className="hot-spot-instruction"
                                                 dangerouslySetInnerHTML={{__html: this.state.locale.instructions}}/>
                                            :
                                            null
                                        }


                                        {this.state.screen.sub_screens.map((sub_screen, index) =>
                                            sub_screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT && this.state.screenIsReady
                                                ?
                                                <HotSpot key={`${sub_screen.screen_id}_hotspot`}
                                                         parentScreen={this.state.screen}
                                                         screen={sub_screen}
                                                         activeScreenId={this.state.activeScreen.screen_id}
                                                         enabledScreens={this.state.enabledScreens}
                                                         completeScreens={this.state.completeScreens}
                                                         settings={this.state.settings}
                                                         isFirstScreen={index === 0}
                                                         isLastScreen={index === (this.state.screen.sub_screens.length -1)}
                                                         onClickFunc={this.setActiveHotspot}/>
                                                :
                                                null
                                        )}


                                            <button className={`btn guroo-btn hot-spot-continue-btn`} onClick={this.navigateToNextScreen} disabled={this.getContinueState()}
                                                    style={this.setButtonColour()} ref={this.continueBtn}>{this.state.continue_label}</button>

                                    </div>
                                    :
                                    <div className="floating-notes">
                                        {
                                            this.state.producerNotes.show_notes || !this.state.producerNotes.show_content
                                                ?
                                                <ProducerNotes notes={this.state.producerNotes.notes}
                                                               screen_id={this.state.screen.screen_id}/>
                                                :
                                                null
                                        }
                                        {
                                            !this.state.screenIsReady
                                                ?
                                                <NotReadyYet screen_id={this.state.screen.screen_id}
                                                             onContinue={this.navigateToNextScreen}/>
                                                :
                                                null

                                        }



                                    </div>
                                }
                            </div>
                        </div>

                        {
                            this.showFooter()
                                ?
                                <div className={`hot-spot-footer ${this.state.scrollState}`}>

                                    <div className="footer-btn" onClick={this.scrollToBottom}
                                         onKeyDown={this.setKeyboardAccessibility} role="presentation"/>

                                    <div className="footer-col text-center">
                                        {
                                            this.state.scrollState === 'scroll' && this.state.screen.hotspot_type !== objectConstants.HOT_SPOT_TYPE_FULL_SCREEN

                                                ?
                                                <div className="scroll-instruction">{this.state.scroll_label}</div>
                                                :
                                                null
                                        }
                                    </div>

                                </div>
                                : null
                        }
                    </div>
                </div>


            </div>


        );
    }
}


HotspotScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

HotspotScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {

    let lang = state.userData.lang;
    return {
        contentData: state.contentData,
        lang: lang,
        titles: state.titles,
        userData: state.userData,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HotspotScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/hotspotScreen/HotspotScreen.js
 **/